
import { Customer, Group } from "@/types/profile";

// Mock customer data - matches database UUIDs
export const mockCustomers: Customer[] = [
  { id: "11111111-1111-1111-1111-111111111111", name: "Acme Corp" },
  { id: "22222222-2222-2222-2222-222222222222", name: "Global Industries" },
  { id: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa", name: "Initech" },
  { id: "55555555-5555-5555-5555-555555555555", name: "Umbrella Corporation" },
];

// Mock group data
export const mockGroups: Group[] = [
  { id: "g1", name: "IT Department", customerId: "11111111-1111-1111-1111-111111111111" },
  { id: "g1-1", name: "Helpdesk", customerId: "11111111-1111-1111-1111-111111111111", parentId: "g1" },
  { id: "g1-2", name: "Endpoint Team", customerId: "11111111-1111-1111-1111-111111111111", parentId: "g1" },
  { id: "g2", name: "Marketing", customerId: "11111111-1111-1111-1111-111111111111" },
  { id: "g3", name: "Sales", customerId: "11111111-1111-1111-1111-111111111111" },
  { id: "g4", name: "Engineering", customerId: "22222222-2222-2222-2222-222222222222" },
  { id: "g5", name: "Finance", customerId: "22222222-2222-2222-2222-222222222222" },
  { id: "g6", name: "Executive", customerId: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa" },
  { id: "g7", name: "Research", customerId: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa" },
  { id: "g7-1", name: "AI Lab", customerId: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa", parentId: "g7" },
  { id: "g8", name: "Development", customerId: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa" },
  { id: "g9", name: "Operations", customerId: "55555555-5555-5555-5555-555555555555" },
  { id: "g10", name: "Security", customerId: "55555555-5555-5555-5555-555555555555" },
];

// Helper function to get groups by customer ID
export const getGroupsByCustomerId = (customerId: string): Group[] => {
  return mockGroups.filter(group => group.customerId === customerId);
};

